import click from './parameters/click'
import clickOfferConsig from './parameters/click/consignado-offer'
import common from './parameters/common'
import screenView from './parameters/screenView'
import simulation from './parameters/simulation/consignado'
import visualization from './parameters/visualization/consignado'

const tracking = {
  trackEvent: ({ event_name = '', parameters = {} }) => {
    const payload = {
      event_name,
      parameters: {
        ...parameters,
        ...common()
      }
    }

    console.log({ payloadTrackEvent: payload })

    return payload
  },
  trackScreenView: (key) => {
    const parameters = screenView(key)
    const hasParameters = Object.keys(parameters).length
    if (!hasParameters) {
      return
    }

    const payload = {
      event_name: 'screen_view',
      parameters
    }

    console.log({ payloadTrackScreenView: payload })

    return payload
  },
  trackClick: (key) => {
    const parameters = click(key)
    const hasParameters = Object.keys(parameters).length
    if (!hasParameters) {
      return
    }

    const payload = {
      event_name: 'click',
      parameters
    }

    console.log({ payloadTrackClick: payload })

    return payload
  },
  trackClickOfferConsig: (key) => {
    const parameters = clickOfferConsig(key)

    const payload = {
      event_name: 'click',
      parameters
    }

    console.log({ payloadTrackClickOfferConsig: payload })

    return payload
  },
  trackSimulation: (args) => {
    const parameters = simulation(args)

    const payload = {
      event_name: 'simulation',
      parameters
    }

    console.log({ payloadTrackSimulation: payload })

    return payload
  },
  trackVisualization: (args) => {
    const parameters = visualization(args)

    const payload = {
      event_name: 'visualization',
      parameters
    }

    console.log({ payloadTrackVisualization: payload })

    return payload
  },
  setUserProperties: (leadUUID = '') => {
    const payload = {
      user: {
        user_id: leadUUID,
        person_id: leadUUID
      }
    }

    console.log({ payloadSetUserProperties: payload })

    return payload
  }
}

export default tracking
